import React, { PureComponent } from 'react';
import isEqual from 'lodash/isEqual';

import tryMe from '../../../helpers/tryMe';
import AvatarUploader from '../../AvatarUploader/AvatarUploader';
import FormSubmit from '../../../containers/Forms/FormSubmit';
import SlateTextInput from '../../Shared/SlateTextInput';
import { avatarShapes } from '../../../config/constants';
import styles from '../styles';

export default class FormStackSettingsBasicInfo extends PureComponent {
  componentDidMount() {
    const { currentAccount, actions, getAccount } = this.props;

    if (currentAccount) {
      getAccount(currentAccount.uuid);

      actions.setFormState({
        name: currentAccount.name,
        imageUUID: currentAccount.imageUUID,
        attachments: [],
        dataErrors: {},
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.currentAccount, this.props.currentAccount)) {
      this.props.getAccount(nextProps.currentAccount.uuid);

      this.props.actions.setFormState({
        name: nextProps.currentAccount.name,
        imageUUID: nextProps.currentAccount.imageUUID,
        attachments: [],
        dataErrors: {},
      });
    }
  }

  render() {
    const { actions, state, t, currentAccount, errorAction } = this.props;
    const isPersonalAccount = this.checkPersonalAccount();

    return (
      <form onKeyPress={actions.handleKeyPress}>
        {currentAccount && currentAccount.error && (
          <div style={styles.formError}>{currentAccount.error}</div>
        )}

        <SlateTextInput
          name="name"
          type="text"
          label={t('stackSettings:stackName')}
          placeholder={t('stackSettings:stackName')}
          fullWidth={true}
          value={tryMe(state).name || ''}
          onChange={actions.handleChange}
          onBlur={actions.handleBlur}
          disabled={isPersonalAccount}
          error={tryMe(state.dataErrors).name || ''}
        />

        <div style={styles.accountLogoTitle}>
          {t('stackSettings:stackLogo')}
        </div>

        {currentAccount && (
          <AvatarUploader
            onAddAttachment={actions.handleAddAttachment}
            onRemoveAttachment={actions.handleRemoveProfileImage}
            onRestoreAttachment={actions.handleRestoreProfileImage}
            imageUUID={state.imageUUID}
            type={this.props.type}
            shape={avatarShapes.ROUNDED_CORNERS}
            t={t}
            disabled={isPersonalAccount}
          />
        )}

        {errorAction && (
          <div className="form-error form-error-action">{errorAction}</div>
        )}

        <FormSubmit
          title={t('btn:updateStack')}
          handleSubmit={actions.handleSubmit}
          entityName={state.entityName}
          disabled={isPersonalAccount}
        />
      </form>
    );
  }

  checkPersonalAccount = () => {
    const { currentUser, currentAccount } = this.props;
    let result = false;

    if (currentUser && currentAccount) {
      result = currentUser.personalAccountUUID === currentAccount.uuid;
    }
    return result;
  };
}
